($('a[data-toggle=modal]')).on('click', function() {
  const target = ($(this)).attr('data-target');
  const url = ($(this)).attr('href');
  return ($.find(target)).load(url);
});